// ./src/utils/azure//azure-storage-blob.ts

// <snippet_package>
// NOT MEANT FOR PRODUCTION OR HOTFIX
import { AnonymousCredential, BlobServiceClient} from '@azure/storage-blob';

const containerName = `decrypted-files`;

// </snippet_package>

// <snippet_isStorageConfigured>
// Feature flag - disable storage feature to app if not configured

export const getStorageConfig = (envCode) => {
  var storageConfig = {
    storageAccountName: '',
    sasToken: '',
  }
  
  switch(envCode.toLowerCase()) {
    case 'dev':
      storageConfig.storageAccountName = process.env.REACT_APP_STORAGERESOURCENAME_DEV;
      storageConfig.sasToken = process.env.REACT_APP_STORAGESASTOKEN_DEV;
      break;
    case 'sit':
      storageConfig.storageAccountName = process.env.REACT_APP_STORAGERESOURCENAME_SIT;
      storageConfig.sasToken = process.env.REACT_APP_STORAGESASTOKEN_SIT;
      break;
    case 'uat':
      storageConfig.storageAccountName = process.env.REACT_APP_STORAGERESOURCENAME_UAT;
      storageConfig.sasToken = process.env.REACT_APP_STORAGESASTOKEN_UAT;
      break;
    case 'trg':
      storageConfig.storageAccountName = process.env.REACT_APP_STORAGERESOURCENAME_TRG;
      storageConfig.sasToken = process.env.REACT_APP_STORAGESASTOKEN_TRG;
      break;
    default:
      storageConfig.storageAccountName = '';
      storageConfig.sasToken = '';
  }
  if(process.env.REACT_APP_LOGGING_LEVEL !== '0') {
  console.log('Storage Configuration Object = ',JSON.stringify(storageConfig));}
  return storageConfig;
}

export const isStorageConfigured = (env) => {
  if(process.env.REACT_APP_LOGGING_LEVEL !== '0') {
  console.log('Storage Configuration Code = ',env);}
  var currentConfig = getStorageConfig(env)
  return (!currentConfig.storageAccountName || !currentConfig.sasToken) ? false : true;
}
// </snippet_isStorageConfigured>

// <snippet_getBlobsInContainer>
// return list of blobs in container to display
const getBlobsInContainer = async (containerClient,storageAccount) => {
  const returnedBlobUrls = [];

  // get list of blobs in container
  // eslint-disable-next-line
  for await (const blob of containerClient.listBlobsFlat()) {
    // if image is public, just construct URL
    returnedBlobUrls.push(
      `https://${storageAccount}.blob.core.windows.net/${containerName}/${blob.name}`
    );
  }

  return returnedBlobUrls;
}
// </snippet_getBlobsInContainer>

// <snippet_createBlobInContainer>
const createBlobInContainer = async (containerClient, file, path) => {
  // create relative path for data
  const blobPath = path + '/' + file.name;
  if(process.env.REACT_APP_LOGGING_LEVEL !== '0') {
    console.log('file Name = ', file.name);
    console.log('file Path = ', path);
    console.log('Blob Path = ', blobPath);
  }
  // create blobClient for container
  const blobClient = containerClient.getBlockBlobClient(blobPath);

  // set mimetype as determined from browser with file upload control
  const options = { blobHTTPHeaders: { blobContentType: file.type } };

  // upload file
  await blobClient.uploadData(file, options);
}
// </snippet_createBlobInContainer>

// <snippet_uploadFileToBlob>
const uploadFileToBlob = async (file, path, env) => {
  if (!file || !env) return [];

  const storageConfig = getStorageConfig(env);
  // get BlobService = notice `?` is pulled out of sasToken - if created in Azure portal
  const blobService = new BlobServiceClient(
    `https://${storageConfig.storageAccountName}.blob.core.windows.net/?${storageConfig.sasToken}`,
    new AnonymousCredential()
  );

  // get Container - full public read access
  const containerClient = blobService.getContainerClient(containerName);
  /*
  await containerClient.createIfNotExists({
    access: 'container',
  });
  */

  if(process.env.REACT_APP_LOGGING_LEVEL !== '0') {
    console.log('Uploading Path ... ', path );
    console.log('Uploading File ... ', file );
  }
  // upload file
  await createBlobInContainer(containerClient, file, path);

  // get list of blobs in container
  return getBlobsInContainer(containerClient,storageConfig.storageAccountName);
};
// </snippet_uploadFileToBlob>

export default uploadFileToBlob;
